// extracted by mini-css-extract-plugin
export var fadeInOut = "_35-3";
export var icon = "_35-4";
export var savedIndicator = "_35-2";
export var savingIndicator = "_35-0";
export var spin = "_35-1";